const CHARACTERS = 'abcdefghijklmnopqrstuvwxyz0123456789';

export function randStr(len: number) {
  let result = '';
  for ( let i = 0; i < len; i++ ) {
    result += CHARACTERS.charAt(Math.floor(Math.random() * CHARACTERS.length));
  }
  return result;
}
